module.exports = __webpack_public_path__ + "img/sceneca_7.e27def18.png";